module.exports = __webpack_public_path__ + "img/activity12.ee0e5a80.png";